import { action, observable } from 'mobx'

import Ds from './ds'

class Terms {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllTerms() {
    this.ds.query(`{ terms(hash: "${ localStorage.getItem('userHash') }") { id terms } }`, (data) => {
      this.data = data.terms
    })
  }
}

export default new Terms()



// WEBPACK FOOTER //
// ./src/stores/terms.js